import config from '../constants/config';

export const userService = {
    update,
    register,
    login,
    logout,
    auth,
};

function update (user) {
    console.log('Update in UserService', user);
    const requestOptions = {
        method:     'POST',
        headers:    { 'Content-Type': 'application/json' },
        body:       JSON.stringify(user),
    };
    return fetch(`${config.apiUrl}/users/update/`, requestOptions).then(handleResponse);
}

function register (user) {
    console.log('Register in UserService', user);
    const requestOptions = {
        method:     'POST',
        headers:    { 'Content-Type': 'application/json' },
        body:       JSON.stringify(user),
    };
    return fetch(`${config.apiUrl}/users/register/`, requestOptions).then(handleResponse);
}

function login (user) {
    console.log('user', user)
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };
    return fetch (`${config.apiUrl}/users/login/`, requestOptions)
        .then (handleResponse)
        .then (auth => {
            // login successful if there's a user in the response
            if (auth.status === 200) {
                // store user details and basic auth credentials in local storage 
                // to keep user logged in between page refreshes
                //auth.authdata = window.btoa(user.username + ':' + user.password);
                localStorage.setItem('user', JSON.stringify(auth));
            }

            return auth;
        });
}

async function auth (user) {
    console.log('user', user)
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };
    return await fetch (`${config.apiUrl}/users/auth/`, requestOptions)
        .then (handleResponse)
        .then (auth => {
            // login successful if there's a user in the response
            if (auth.status === 200) {
                // store user details and basic auth credentials in local storage 
                // to keep user logged in between page refreshes
                //auth.authdata = window.btoa(user.username + ':' + user.password);
                localStorage.setItem('user', JSON.stringify(auth.user));
            }

            return auth;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
    localStorage.removeItem('token');
}

export function getUserById(id) {
    // const requestOptions = {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({ 'id': id })
    // };
    return fetch (`${config.apiUrl}/users/id/${id}`).then(handleResponse);
}

export function getStripeToken(id) {
    return fetch (`${config.apiUrl}/users/stripetoken/${id}`).then(handleResponse);
}

export function getStripeId(id) {
    return fetch (`${config.apiUrl}/users/stripeid/${id}`).then(handleResponse);
}

export function changePassword(id, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            'id': id,
            'password': password
        })
    };
    return fetch (`${config.apiUrl}/users/changepassword/`, requestOptions)
        .then (handleResponse);
}

export function setStripeToken(id, token) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            'id': id,
            'token': token
        })
    };
    return fetch (`${config.apiUrl}/users/setstripetoken/`, requestOptions)
        .then (handleResponse);
}

export function setStripeId(id, stripeId) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            'id': id,
            'stripeid': stripeId
        })
    };
    return fetch (`${config.apiUrl}/users/setstripeid/`, requestOptions)
        .then (handleResponse);
}

export function resetPassword(id) {
    return fetch(`${config.apiUrl}/api/resetpassword/${id}`).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                window.location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
